
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/open-ai",
      function () {
        return require("private-next-pages/destinations/open-ai.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/open-ai"])
      });
    }
  